import Nullstack from 'nullstack';
export default function IconHighlightOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-highlight-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8.998 9.002l-5.998 5.998v4h4l6 -6m1.997 -1.997l2.503 -2.503a2.828 2.828 0 1 0 -4 -4l-2.497 2.497"
  }), "   ", Nullstack.element("path", {
    d: "M12.5 5.5l4 4"
  }), "   ", Nullstack.element("path", {
    d: "M4.5 13.5l4 4"
  }), "   ", Nullstack.element("path", {
    d: "M19 15h2v2m-2 2h-6l3.004 -3.004"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}